export default __webpack_public_path__ + "static/media/01.58ba3a73.webp";